import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AnimalModel } from '../models/animal.model';
import { FoundReportPreviewContactEntry, FoundReportPreviewPayload } from '../models/found-report-preview-payload.model';

@Injectable({ providedIn: 'root' })
export class FoundReportPreviewBuilderService {
  constructor(private readonly datePipe: DatePipe) {}

  build(args: {
    animal: AnimalModel | null;
    formValue: any;
    shelterId: number;
    contacts: FoundReportPreviewContactEntry[];
  }): FoundReportPreviewPayload {
    const { animal, formValue, shelterId, contacts } = args;

    const r = {
      animal: {
        category: (animal as any)?.category ?? null,
        type: (animal as any)?.type ?? null,
        name: (animal as any)?.name ?? null,
        bookNumber: (animal as any)?.bookNumber ?? null,
        oldBookNumber: (animal as any)?.oldBookNumber ?? null,
        oldBookNumberList: (animal as any)?.oldBookNumberList ?? null,
        breed: (animal as any)?.breed ?? null,
        sex: (animal as any)?.sex ?? null,
        transponderNumber: (animal as any)?.transponderNumber ?? null,
        tattoo: (animal as any)?.tattoo ?? null,
        ringNumber: (animal as any)?.ringNumber ?? null,
        specialInformation: (animal as any)?.specialInformation ?? null,
        coatType: (animal as any)?.coatType ?? null,
        coatColor: (animal as any)?.coatColor ?? null,
        badge: (animal as any)?.badge ?? null,
        specialNotice: (animal as any)?.specialNotice ?? null,
      },
      animalOrigin: {
        foundStatus: formValue.foundStatus ?? null,
        specialInformation: formValue.originSpecialInformation ?? null,
        location: formValue.originLocation,
        foundDateTime: formValue.foundDateTime ?? null,
        pickupUserName: formValue.pickupUserName ?? null,
        pickupDateTime: formValue.pickUpDateTime ?? formValue.pickupDateTime,
        consentToShareWithOwner: !!formValue.consentToShareWithOwner,
        careCondition: (formValue.careCondition ?? []) as string[],
        temperament: (formValue.temperament ?? []) as string[],
        bcsNutrition: (formValue.bcsNutrition ?? null) as string | null
      },
      contacts: contacts,
      animalShelter: { id: shelterId }
    };

    return r
  }
}
